<template>
  <v-card v-if="hasSocket" class="chat-card">
    <v-card-title class="bar-title"> Contacter Hublot </v-card-title>
    <v-card-text>
      <div id="chat-messages" class="chat-messages">
        <template v-for="(sortedMessage, i) in sortedMessages">
          <div v-if="i !== 'undefined'" :key="'hr-' + i" class="hr-sect">
            <span class="message-date">{{ i }} </span>
          </div>
          <div v-for="(message, index) in sortedMessage" :key="'message-' + message.id">
            <div :key="`message-${i}-${index}`" class="message-wrapper" :class="message.source === 'crm'
              ? 'message-wrapper-right'
              : 'message-wrapper-left'
              ">
              <div class="chat-bubble" :class="message.source === 'crm' ? 'message-left' : 'message-right'
                ">
                <div class="chat-message-date">
                  <div>
                    <v-row no-gutters>
                      {{ message.username }}
                      <v-spacer />
                      <v-row justify="end" no-gutters :class="message.source === 'crm'
                        ? 'message-left'
                        : 'message-right'
                        ">
                        {{ message.date | formatHour }}
                      </v-row>
                    </v-row>
                  </div>
                </div>
                <v-divider />
                <v-row v-if="
                  message.text &&
                  message.text.length > 0 &&
                  message.text !== ' '
                " justify="start" no-gutters>
                  {{ message.text }}
                </v-row>
                <v-row v-else-if="message.command && message.command.length > 0" justify="start" no-gutters>
                  <pre>Commande envoyée par le support Hublot</pre>
                </v-row>
                <v-row v-if="
                  message.attachment !== 'null' &&
                  message.attachment !== '' &&
                  message.attachment !== null
                " justify="start" no-gutters>
                  <ChatImage :date="message.date" :file="message.attachment" />
                </v-row>
                <br />
              </div>
            </div>
          </div>
        </template>
      </div>
      <v-divider />
      <v-row no-gutters align="center">
        <v-menu top offset-y nudge-top="50">
          <template #activator="{ on }">
            <v-btn :elevation="selectedEmploye ? 6 : 2" class="chat-employe-icon" icon :outlined="!selectedEmploye"
              :color="selectedEmploye !== null
                ? selectedEmploye.color !== null
                  ? selectedEmploye.color
                  : 'primary darken-2'
                : 'grey darken-2'
                " @click="toggleEmployee" v-on="on">
              <v-icon v-if="selectedEmploye === null"> people </v-icon>
              <span v-else>{{ selectedEmploye.inits }}</span>
            </v-btn>
          </template>
          <v-card>
            <v-col class="employe-list scroller-bar">
              <v-list v-for="employe in employesList" :key="employe.id" dense>
                <v-list-item>
                  <v-list-item-avatar>
                    <v-icon :color="employe.color"> people </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content @click="selectEmploye(employe)">
                    <v-list-item-title>
                      <b v-if="
                        selectedEmploye &&
                        employe.name === selectedEmploye.name
                      ">{{ employe.name }}</b>
                      <span v-else>{{ employe.name }}</span>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon v-if="
                      selectedEmploye && selectedEmploye.id === employe.id
                    " @click="removeSelectedEmploye()">
                      close
                    </v-icon>
                  </v-list-item-action>
                </v-list-item>
                <v-divider :key="'divider-' + employe.id" />
              </v-list>
            </v-col>
          </v-card>
        </v-menu>
        <v-row no-gutters class="ml-2 mr-2">
          <v-textarea v-model="text" rows="1" row-height="12" :auto-grow="true" class="input-message-text"
            label="Entrez votre message" clearable :disabled="isSending" @keydown.enter="sendMessage()" />
        </v-row>
        <v-btn text icon color="primary" :disabled="text.length < 1" @click="sendMessage()">
          <v-icon size="30"> send </v-icon>
        </v-btn>
      </v-row>
    </v-card-text>
  </v-card>
  <v-card v-else class="d-flex flex-column align-center justify-center" style="height: 84vh; width: 78vw"
    color="grey-darken-4" elevation="0">
    <v-icon size="80" color="red lighten-1">signal_wifi_off</v-icon>

    <div class="text-center mt-4 px-4">
      <h2 class="text-h6 font-weight-medium">
        Pas de connexion
        <pre>Service Chat indisponible</pre>
        <br /><br />
        Le chat ne peut pas se charger pour l'instant
      </h2>
    </div>
  </v-card>
</template>

<script>
import groupby from 'lodash.groupby'
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import ChatImage from '@/components/chatImage.vue'

export default {
  components: { ChatImage },
  props: ['dialog'],
  data() {
    return {
      menu: false,
      text: '',
      selectedEmploye: null,
      employeState: false,
      isSending: false,
      socketCheckInterval: 0
    }
  },
  computed: {
    hasSocket() {
      const socket = this.getSocket
      const isSocketConnected = socket.connected ?? false
      return isSocketConnected
    },
    employesList() {
      return this.employees.map(employe => ({
        id: employe.idEmployees,
        color: employe.color,
        name: `${employe.prenom} ${employe.nom}`,
        inits: employe.prenom.charAt(0) + employe.nom.charAt(0)
      }))
    },
    sortedMessages() {
      // 1. Flatten
      const flatItems = Object.values([...this.messages]).flat()

      // Grouper par date formatée ou "Sans date"
      const grouped = groupby(flatItems, item => (item.date ? moment(item.date).format('YYYY-MM-DD') : 'Sans date'))

      // Trier les messages dans chaque jour
      Object.entries(grouped).forEach(([key, items]) => {
        grouped[key] = items.sort((a, b) => moment(a.date).diff(moment(b.date)))
      })

      // Trier les groupes : "Sans date" d'abord, puis les autres par date décroissante
      const sortedGroups = [
        ...(grouped['Sans date'] ? [['Sans date', grouped['Sans date']]] : []),
        ...Object.entries(grouped)
          .filter(([key]) => key !== 'Sans date')
          .sort((a, b) => moment(a[0]).diff(moment(b[0])))
      ]

      // Reformater les clés avec format intelligent
      const final = Object.fromEntries(
        sortedGroups.map(([key, items]) => {
          const label = key === 'Sans date' ? 'Sans date' : this.formatSmartDate(key)
          return [label, items]
        })
      )

      return final
    },
    ...mapGetters(['getSocket']),
    ...mapState({
      messages: state => state.chat.messages,
      client: state => state.authentication.client,
      employees: state => state.notilus.employees,
      userProfile: state => state.authentication.userProfile,
    })
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.scrollTop()
      }
    },
    messages() {
      this.scrollTop()
    }
  },
  created() {
    this.scrollTop()
    this.$store.dispatch('getEmployees')

    this.socketCheckInterval = setInterval(() => {
      if (!this.hasSocket) {
        console.warn('Socket déconnecté, tentative de reconnexion...')
        this.$store.dispatch('joinAndListen', this.client.serial)
      }
    }, 10000) // toutes les 10 secondes
  },
  beforeDestroy() {
    clearInterval(this.socketCheckInterval)
  },
  methods: {
    toggleEmployee() {
      this.employeState = !this.employeState
    },
    selectEmploye(employe) {
      this.selectedEmploye = employe
    },
    removeSelectedEmploye() {
      this.selectedEmploye = null
    },
    formatSmartDate(rawDate) {
      const date = moment(rawDate)
      const currentYear = moment().year()

      return date.year() === currentYear ? date.format('DD/MM') : date.format('DD/MM/YYYY')
    },
    scrollTop() {
      if (this.dialog) {
        if (this.messages.filter(message => message.source === 'crm' && message.seen_by === null).length > 1) {
          const lastMessageId = this.messages
            .filter(message => message.source === 'crm' && message.seen_by === null)
            .sort((a, b) => new Date(b.date) - new Date(a.date))[0].id
          this.$store.dispatch('setRead', lastMessageId)
        }
      }
      setTimeout(() => {
        const chatMessage = document.getElementById('chat-messages')
        if (chatMessage) {
          chatMessage.scrollTop = chatMessage.scrollHeight
        }
      }, 200)
    },
    sendMessage() {
      if (this.isSending) return // Empêche les appels multiples
      this.isSending = true
      let username = null;
      if (this.selectedEmploye) {
        username = this.selectedEmploye.name;
      } else if (this.userProfile) {
        username = `${this.userProfile.firstName} ${this.userProfile.lastName}`;
      }
      const payload = {
        serial: this.client.serial,
        text: this.text,
        mode: 'support',
        current_route: this.$route.path,
        source: 'magasin',
        username: username
      }

      this.$store
        .dispatch('sendMessage', payload)
        .then(() => {
          this.$store.dispatch('loadMessages')
          this.text = ''
        })
        .finally(() => {
          this.isSending = false // Réautorise l'envoi
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars";
@import "@/assets/scss/scroller";

.chat-card {
  z-index: 99 !important;
}

.area-line-height {
  line-height: 1.3rem;
}

.chat-message {
  padding: 5px 10px 5px 10px;
  word-break: break-word;
}

.chat-bubble {
  // border-radius: 5px;
  display: inline-block;
  padding: 10px 18px;
  position: relative;
  margin: 10px;
  max-width: 80%;
}

.chat-message-date {
  font-style: italic;
  font-size: 0.8rem;
  margin-top: -5px;
}

.chat-bubble:before {
  content: "\00a0";
  display: block;
  height: 16px;
  width: 9px;
  position: absolute;
  bottom: -7.5px;
}

.message-right {
  width: fit-content;
  border-radius: 15px 15px 10px 15px;
  text-align: left;
  font-weight: 600;
  margin-left: auto;
  background-color: $primary;
  color: #f0f2f5;
  padding: 1%;
  min-width: 150px;
}

.message-left {
  width: fit-content;
  border-radius: 15px 15px 15px 10px;
  text-align: left;
  font-weight: 400;
  margin-right: auto;
  color: black;
  background-color: #f0f2f5;
  padding: 1%;
  min-width: 150px;
}

.chat-bubble.message-left:before {
  background-color: #f0f2f5;
  left: 12px;
  -webkit-transform: rotate(70deg) skew(5deg);
}

.chat-bubble.message-right {
  background-color: $primary;
  color: #fff;
  float: right;
  margin-right: 5px;
}

.chat-bubble.message-right:before {
  background-color: $primary;
  right: 12px;
  -webkit-transform: rotate(118deg) skew(-5deg);
}

.chat-messages {
  max-height: 52vh;
  overflow: auto;
  padding-right: 1%;
}

.message-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.message-wrapper-left {
  flex-direction: row-reverse;
  justify-content: flex-start;
}

.message-wrapper-left:hover .addTask_btn {
  background-color: #e0e0e0;
  border-color: #e0e0e0;
}

.message-wrapper-right {
  flex-direction: row;
  justify-content: flex-start;
}

.message-wrapper-right:hover .addTask_btn {
  background-color: #cfd8dc;
  border-color: #e0e0e0;
}

.message-date {
  text-transform: uppercase;
  border: 1px solid lightgrey;
  color: grey;
  font-weight: 400;
  border-radius: 8px;
  padding: 0px 15px 0px 15px;
  font-size: 0.9rem;
}

.hr-sect {
  display: flex;
  flex-basis: 100%;
  align-items: center;
  color: rgba(0, 0, 0, 0.15);
  font-size: 12px;
  margin: 8px 0px;
}

.hr-sect::before,
.hr-sect::after {
  content: "";
  flex-grow: 1;
  background: rgba(0, 0, 0, 0.15);
  height: 1px;
  font-size: 0px;
  line-height: 0px;
  margin: 0px 16px;
}

.employe-list {
  max-height: 15vw;
  overflow-y: scroll;
}
</style>
